import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";

import { AccessLeaseExtensionRequest, EXTENSION_DURATION_OPTIONS } from "@bitwarden/bit-pam";
import {
  AsyncActionsModule,
  ButtonModule,
  DialogModule,
  DialogRef,
  DialogService,
  FormFieldModule,
  SelectModule,
} from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

/** Collects a lease extension. The reason is required because the server rejects an empty one. */
@Component({
  selector: "pam-extend-lease-dialog",
  templateUrl: "./extend-lease-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncActionsModule,
    ButtonModule,
    DialogModule,
    FormFieldModule,
    ReactiveFormsModule,
    SelectModule,
    I18nPipe,
  ],
})
export class ExtendLeaseDialogComponent {
  private readonly dialogRef =
    inject<DialogRef<AccessLeaseExtensionRequest | undefined>>(DialogRef);
  private readonly formBuilder = inject(FormBuilder);

  protected readonly durationOptions = EXTENSION_DURATION_OPTIONS;

  protected readonly formGroup = this.formBuilder.nonNullable.group({
    durationSeconds: [EXTENSION_DURATION_OPTIONS[0].seconds, Validators.required],
    reason: ["", Validators.required],
  });

  protected readonly submit = async (): Promise<void> => {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      return;
    }
    const { durationSeconds, reason } = this.formGroup.getRawValue();
    void this.dialogRef.close({ durationSeconds, reason });
  };

  static open(dialogService: DialogService): DialogRef<AccessLeaseExtensionRequest | undefined> {
    return dialogService.open(ExtendLeaseDialogComponent);
  }
}
